import React from 'react';
import PrintLayout from './PrintLayout';

const CATEGORIES = [
  { key: 'cc', label: 'Compelling Content', color: '#5f7942' },
  { key: 'hb', label: 'Healthy Behaviors',  color: '#cba43a' },
  { key: 'rg', label: 'Right Chemistry',    color: '#7209b7' },
  { key: 'sp', label: 'Simple Process',    color: '#2a3d5b' },
];

export default function PrintObservations({ pageNumber, inventoryScores, teamPerception, portrait }) {
  // inventoryScores: { sp: 0-100, cc: 0-100, hb: 0-100, rg: 0-100 } — consultant observed %
  // teamPerception: { sp: 0-100, cc: 0-100, hb: 0-100, rg: 0-100 } — team self-assessment %

  return (
    <PrintLayout pageNumber={pageNumber}>
      <div style={{ position: 'absolute', top: 0, bottom: 68, left: 0, right: 0, padding: '5% 6%', background: '#f5f4f0' }}>
        <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: 24, fontWeight: 700, color: '#1e2e45', marginBottom: 8 }}>
          Observations
        </div>
        <div style={{ fontSize: 9, color: '#6b757e', marginBottom: 24, fontStyle: 'italic' }}>
          Team self-perception vs. consultant observation across the last 5 meetings.
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: portrait ? 28 : 20 }}>
          {CATEGORIES.map(({ key, label, color }) => {
            const observed = Math.round(inventoryScores?.[key] ?? 0);
            const perceived = Math.round(teamPerception?.[key] ?? 0);
            const gap = perceived - observed;
            const rows = [['Consultant Observed', observed, color]];
            if (perceived > 0) rows.push(['Team Perceived', perceived, '#6b757e']);
            return (
              <div key={key}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: portrait ? 8 : 6 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color }}>{label}</div>
                  {perceived > 0 && (
                    <div style={{ fontSize: 9, fontWeight: 600, color: gap > 10 ? '#922b3f' : gap < -10 ? '#5f7942' : '#6b757e' }}>
                      Gap: {gap > 0 ? '+' : ''}{gap}%
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: portrait ? 10 : 4 }}>
                  {rows.map(([lbl, val, clr]) => (
                    <div key={lbl}>
                      {portrait && (
                        <div style={{ fontSize: 8, color: '#6b757e', marginBottom: 3 }}>{lbl}</div>
                      )}
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        {!portrait && (
                          <div style={{ width: 130, fontSize: 8, color: '#6b757e', flexShrink: 0 }}>{lbl}</div>
                        )}
                        <div style={{ flex: 1, height: portrait ? 14 : 10, background: '#ececed', borderRadius: 5 }}>
                          <div style={{ width: `${val}%`, height: '100%', background: clr, borderRadius: 5 }} />
                        </div>
                        <div style={{ width: 36, fontSize: 9, fontWeight: 700, color: clr, textAlign: 'right' }}>{val}%</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </PrintLayout>
  );
}
